/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { Form } from '@klp/form';

import type { Message } from '../classes';

import { MessageFormContent } from './MessageFormContent';

const useStyles = makeStyles((_theme: Theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column' as const,
        flexGrow: 1,
        margin: '1em 0',
        '& > *': {
            marginBottom: '2em !important',
            flexBasis: 'auto',
        },
    },
}));

type MessageFormMode = 'add' | 'edit';

interface IProps {
    mode: MessageFormMode;
    message: Message;
    disabled?: boolean;
    isLoading?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSubmit: (event: any, values: any) => void;
    onCancel: () => void;
}

export const MessageForm: React.FC<IProps> = ({
    mode,
    message,
    disabled,
    isLoading = false,
    onSubmit,
    onCancel,
}) => {
    const classes = useStyles();

    return (
        <Form
            className={classes.form}
            onSubmit={onSubmit}
            values={{
                id: message.id,
                status: message.status,
                title: message.title,
                content: message.content,
                category: message.category,
                publishAt: message.publishAt,
                expiresAt: message.expiresAt,
                mottakereList: message.mottakereList,
                notifyByEMail: message.notifyByEMail,
                isPinned: message.isPinned,
                attachments: message.attachments,
            }}
            disabled={disabled}
        >
            <MessageFormContent
                mode={mode}
                message={message}
                isLoading={isLoading}
                onCancel={onCancel}
            />
        </Form>
    );
};
